import { UploadStatusValueDto } from "../../../autogen/bff-api";

export type ImageUploadStatus =
  | { state: "uploading"; progress: number }
  | { state: "processing" }
  | { state: "ready" }
  | { state: "failed" };

const processingStateMap: Record<UploadStatusValueDto, "processing" | "ready" | "failed"> = {
  [UploadStatusValueDto.Processing]: "processing",
  [UploadStatusValueDto.Confirmed]: "ready",
  [UploadStatusValueDto.Failed]: "failed",
};

export const processingStateFromStatus = (status: UploadStatusValueDto): "processing" | "ready" | "failed" =>
  processingStateMap[status];
